import FourOhFour from 'Scenes/FourOhFour';
import Home from 'Scenes/Home';
import PractitionerDashboard from 'Scenes/PractitionerDashboard';
import PractitionerLogin from 'Scenes/PractitionerLogin';
import PractitionerRegister from 'Scenes/PractitionerRegister';
import PatientLogin from 'Scenes/PatientLogin';
import PatientMeeting from 'Scenes/PatientMeeting';
import PatientMeetingComplete from 'Scenes/PatientMeetingComplete';

export default {
  HOME: Home,
  FOUR_OH_FOUR: FourOhFour,
  PRACTITIONER_DASHBOARD: PractitionerDashboard,
  PRACTITIONER_LOGIN: PractitionerLogin,
  PRACTITIONER_REGISTER: PractitionerRegister,
  PATIENT_LOGIN: PatientLogin,
  PATIENT_MEETING: PatientMeeting,
  PATIENT_MEETING_COMPLETE: PatientMeetingComplete,
};
